const styles = (theme) => ({
  services: {
    maxHeight: '100px',
    paddingRight: '1.143rem',
    gridRow: 1,
    gridColumn: 3,
    '@media(max-width:991px)': {
      paddingBottom: '1.143rem',
      paddingRight: 0
    },
    '@media(max-width:768px)': { gridRow: 3, gridColumn: 1 }
  },
  category: {
    fontWeight: 700,
    color: 'black',
    margin: 'auto 0'
  },

  item: {
    width: '100%',
    height: '100%',
    maxWidth: '300px',
    margin: 'auto 0',
    maxHeight: '25px',
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    gridTemplateRows: '20px',
    '-ms-grid-columns': '1fr auto',
    '-ms-grid-rows': '20px',
    '@media(max-width:992px)': {
      maxWidth: '100%'
    }
  },

  itemName: {
    margin: 0,
    padding: 0,
    transition: 'padding-left 0.15s',
    gridRow: 1,
    gridColumn: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    height: 20,
    alignSelf: 'center'
  },
  label: {
    color: theme.nav,
    paddingRight: 10,
    background: theme.navText,
    textTransform: 'uppercase',
    fontSize: '0.7143rem',
    padding: 5,
    margin: '0 10px',
    borderRadius: 4,
    gridRow: 1,
    gridColumn: 2,
    alignSelf: 'center',
    textAlign: 'center',
    fontWeight: 700
  }
});

export default styles;
